import * as React from "react";
import { useState } from "react";
import CheckoutUserCreateAccount from "./checkoutusercreateaccount";
import CheckoutUserLogin from "./checkoutuserlogin";

const CheckoutUserAccount = () => {
    // the user can either create an account or login.
    // we default to create account
    const [createAccount, setCreateAccount] = useState(true);

    const toggleForm = () => {
        setCreateAccount((prev) => !prev);
    };

    if (createAccount) {
        return (
            <>
                <CheckoutUserCreateAccount />
                <div className="form-text">
                    Already have an account?{" "}
                    <button
                        className="btn btn-sm btn-link"
                        onClick={toggleForm}
                    >
                        Sign In
                    </button>
                </div>
            </>
        );
    } else {
        return (
            <>
                <CheckoutUserLogin />
                <div className="form-text">
                    No account yet?{" "}
                    <button
                        className="btn btn-sm btn-link"
                        onClick={toggleForm}
                    >
                        Create Account
                    </button>
                </div>
            </>
        );
    }
};

export default CheckoutUserAccount;
